/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ReportSource } from '../../../api/enumerations';
import { getErrorReport } from '../../../api/errorReport';
import {
  ErrorElementData,
  ErrorReportData,
} from '../../../api/errorReport/types';
import { WorkOrderData } from '../../../api/workOrders/types';
import Snackbar from '../../../components/Snackbar';
import { BackButton } from '../../../components/UI/Button';
import { GridContainer } from '../../../components/UI/Grid';
import { StyledLinearProgress } from '../../../components/UI/Typography';
import { IconArrowCircleLeftMS } from '../../../constants/icons';
import { GlobalContext } from '../../../context/global';
import useErrorMessage from '../../../hooks/useErrorMessage';
import { Element } from './Element';
import { Revision } from './Revision';

export function ReportDetails(): JSX.Element {
  const [errorReport, setErrorReport] = useState<ErrorReportData>();
  const [elementSource, setElementSource] = useState(false);
  const [element, setElement] = useState<ErrorElementData>();
  const [propertyData, setPropertyData] = useState<WorkOrderData>();

  const { openSnackbar, setOpenSnackbar, setErrorMessage, setSnackbarMessage } =
    useContext(GlobalContext);

  const { getErrorMessage } = useErrorMessage();
  const navigate = useNavigate();
  const { id } = useParams();
  const reportId = parseInt(id as string, 10);

  const navigateBack = (): void => {
    navigate('/error-report');
  };

  const getDataCallback = useCallback(async () => {
    try {
      const response = await getErrorReport(reportId);

      if (response.detail.description)
        throw new Error(response.detail.description);

      if (!response.data) throw new Error('Algo deu errado, tente novamente.');

      setErrorReport(response.data);

      if (response.data.report_source === ReportSource.ELEMENT) {
        if (!response.data.sample_description) {
          setSnackbarMessage('Não foi possível carregar o elemento.');
          setErrorMessage(true);
          setOpenSnackbar(true);
          navigateBack();
          return;
        }
        setElementSource(true);
        setElement(response.data.sample_description);
      } else {
        if (!response.data.work_order) {
          setSnackbarMessage('Não foi possível carregar as informações.');
          setErrorMessage(true);
          setOpenSnackbar(true);
          navigateBack();
          return;
        }
        setPropertyData(response.data.work_order);
      }
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error, true));
      setErrorMessage(true);
      setOpenSnackbar(true);
      navigateBack();
    }
  }, []);

  useEffect(() => {
    getDataCallback();
  }, [getDataCallback]);

  return (
    <GridContainer sx={{ minHeight: '100vh' }}>
      <BackButton onClick={navigateBack}>{IconArrowCircleLeftMS}</BackButton>
      {!errorReport ? (
        <StyledLinearProgress sx={{ m: 6 }} />
      ) : (
        <Box>
          {elementSource && element && (
            <Element
              errorReport={errorReport}
              elementData={element}
              errorFindings={errorReport?.findings}
            />
          )}
          {!elementSource && propertyData && (
            <Revision
              errorReport={errorReport}
              propertyData={propertyData}
              errorFindings={errorReport?.findings}
            />
          )}
        </Box>
      )}
      {openSnackbar && <Snackbar />}
    </GridContainer>
  );
}
